import React from 'react';

import buzzfeed from 'marketing-website/media/images/pages/resources/buzzfeed@2x.png';
import cabify from 'marketing-website/media/images/pages/resources/cabify@2x.png';
import cssDevice from 'marketing-website/media/images/pages/resources/css@2x.png';
import deliveroo from 'marketing-website/media/images/pages/resources/deliveroo@2x.png';
import hudl from 'marketing-website/media/images/pages/resources/hudl@2x.png';
import yieldr from 'marketing-website/media/images/pages/resources/yieldr@2x.png';
import monzo from 'marketing-website/media/images/pages/resources/monzo@2x.png';
import sketchPads from 'marketing-website/media/images/pages/resources/sketch-pads@2x.png';
import workshop from 'marketing-website/media/images/pages/resources/ebook@2x.png';
import collaboration from 'marketing-website/media/images/pages/resources/ebook-collaboration@2x.png';
import designSystems from 'marketing-website/media/images/pages/resources/design-systems2x.png';
import usertesting from 'marketing-website/media/images/pages/resources/user-testing-field-guide@2x.png';

import Download from 'marketing-website/components/icons/DownloadBlue';

import Buzzfeed from 'marketing-website/media/documents/pdfs/buzzfeed.pdf';
import Cabify from 'marketing-website/media/documents/pdfs/cabify.pdf';
import Deliveroo from 'marketing-website/media/documents/pdfs/deliveroo.pdf';
import Hudl from 'marketing-website/media/documents/pdfs/hudl.pdf';
import Monzo from 'marketing-website/media/documents/pdfs/monzo.pdf';
import Yieldr from 'marketing-website/media/documents/pdfs/yieldr.pdf';

// note to marketing team: when adding hubspot pages to bits bobs data, prepend the url with /resources/ -- the ones below without this are not hubspot pages
const bitsBobsData = [
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'The User Testing Field Guide',
    image: {
      alt: 'The User Testing Field Guide',
      src: usertesting,
    },
    url: '/resources/free-ebook-user-testing-field-guide',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'Getting Started with Design Systems',
    image: {
      alt: 'Getting Started with Design Systems',
      src: designSystems,
    },
    url: '/ebook-design-systems/',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'The Book of Collaboration: Handoff Edition',
    image: {
      alt: 'The Book of Collaboration',
      src: collaboration,
    },
    url: '/ebook-collaboration-handoff-edition/',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'The Design Thinking Workshop Kit',
    image: {
      alt: 'Design Thinking Worskhop',
      src: workshop,
    },
    url: '/workshops',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'Sketch Pads: Download our free downloadable templates',
    image: {
      alt: 'Sketch Pads',
      src: sketchPads,
    },
    url: '/sketchpad',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: '13 Pure CSS Mobile Devices.css',
    image: {
      alt: 'CSS device',
      src: cssDevice,
    },
    url: 'https://marvelapp.github.io/devices.css/',
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Deliveroo',
    image: {
      alt: 'Marvel for Deliveroo',
      src: deliveroo,
    },
    url: Deliveroo,
    download: true,
    labelLogo: <Download />,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Monzo',
    image: {
      alt: 'Marvel for Monzo',
      src: monzo,
    },
    labelLogo: <Download />,
    url: Monzo,
    download: true,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Yieldr',
    image: {
      alt: 'Marvel for Yielder',
      src: yieldr,
    },
    labelLogo: <Download />,
    url: Yieldr,
    download: true,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Buzzfeed',
    image: {
      alt: 'Marvel for Buzzfeed',
      src: buzzfeed,
    },
    labelLogo: <Download />,
    url: Buzzfeed,
    download: true,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Cabify',
    image: {
      alt: 'Marvel for Cabify',
      src: cabify,
    },
    labelLogo: <Download />,
    url: Cabify,
    download: true,
  },
  {
    labelMessage: 'DOWNLOAD',
    excerpt: 'One-pager Case Study: Marvel for Hudl',
    image: {
      alt: 'Marvel for Hudl',
      src: hudl,
    },
    url: Hudl,
    download: true,
    labelLogo: <Download />,
  },
];

export default bitsBobsData;



// WEBPACK FOOTER //
// ./src/configs/pages/resources/bitsBobsData.js